import "./styles.scss";
import { SWRConfig } from "swr";
import TagManager from "react-gtm-module";
import { CustomProvider } from "./context/CustomContext";
import Help from "./components/Help/index.jsx";
import RoutesApp from "./routes/Routes.jsx";
import { AuthProvider } from "./context/SSO.jsx";

const tagManagerArgs = {
  gtmId: "GTM-WFHXNPQ",
};

// TagManager.initialize(tagManagerArgs);

function App() {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
      }}
    >
      <AuthProvider>
        <CustomProvider>
          {/* <Help title="Help" /> */}

          <RoutesApp />
        </CustomProvider>
      </AuthProvider>
    </SWRConfig>
  );
}

export default App;
